import { TokenInformation } from 'app/auth/TokenInformation';
import { TokenStore } from 'app/api/TokenStore';

/**
 * Store для хранения access токена и refresh токена.
 *
 * В качестве хранилища используется SessionStorage.
 */
class SessionStorageTokenStore implements TokenStore {
    private readonly tokenStorageKey = 'token';

    /**
     * Возвращает access токен.
     */
    get token(): string {
        return sessionStorage.getItem(this.tokenStorageKey);
    }

    /**
     * Устанавливает access токен.
     *
     * Будет брошено исключение при попытке установить пустое значение.
     */
    set token(token: string) {
        if (!token) {
            throw new Error('Token must be specified');
        }

        sessionStorage.setItem(this.tokenStorageKey, token);
    }

    set tokenInformation(tokenInformation: TokenInformation) {
        this.token = tokenInformation.accessToken;
    }

    /**
     * Удаляет данные связанные с токенами из SessionStorage.
     */
    clear() {
        sessionStorage.removeItem(this.tokenStorageKey);
    }

    get tokenExists(): boolean {
        return !!this.token;
    }
}

export default new SessionStorageTokenStore();
